import { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';
import { DialogDescription } from '../ui/dialog';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ScheduleMeetingForm = ({ onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/contact`, {
        ...formData,
        inquiry_type: 'meeting',
      });
      
      toast.success('Meeting request submitted successfully! We\'ll be in touch soon.');
      setFormData({ name: '', email: '', company: '', phone: '', message: '' });
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4" data-testid="schedule-meeting-form">
      <DialogDescription className="text-sm text-slate-500 mb-2">
        Fill out the form below and we'll get back to you within 24 hours.
      </DialogDescription>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="name">Name *</Label>
          <Input
            id="name"
            name="name"
            placeholder="John Doe"
            value={formData.name}
            onChange={handleChange}
            required
            data-testid="meeting-form-name"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="email">Email *</Label>
          <Input
            id="email"
            name="email"
            type="email"
            placeholder="john@company.com"
            value={formData.email}
            onChange={handleChange}
            required
            data-testid="meeting-form-email"
          />
        </div>
      </div>
      
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="company">Company</Label>
          <Input
            id="company"
            name="company"
            placeholder="Acme Inc."
            value={formData.company}
            onChange={handleChange}
            data-testid="meeting-form-company"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="phone">Phone</Label>
          <Input
            id="phone"
            name="phone"
            type="tel"
            placeholder="+1 (555) 000-0000"
            value={formData.phone}
            onChange={handleChange}
            data-testid="meeting-form-phone"
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="message">What would you like to discuss? *</Label>
        <Textarea
          id="message"
          name="message"
          placeholder="Tell us about your project or what you'd like to discuss..."
          value={formData.message}
          onChange={handleChange}
          required
          rows={4}
          data-testid="meeting-form-message"
        />
      </div>

      <Button 
        type="submit" 
        className="w-full bg-slate-900 text-white hover:bg-slate-800 rounded-full btn-click"
        disabled={loading}
        data-testid="meeting-form-submit"
      >
        {loading ? 'Submitting...' : 'Request Meeting'}
      </Button>
    </form>
  );
};

export default ScheduleMeetingForm;
